import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Headphones, PlayCircle } from "lucide-react";
import { Reveal, SectionTitle } from "../components/common";
import { publicApi, mediaUrl } from "../lib/api";

export default function PodcastSeriesList() {
  const [series, setSeries] = useState([]);
  useEffect(() => { publicApi.series().then(setSeries).catch(() => {}); }, []);

  if (series.length === 0) return null;

  return (
    <section className="py-16 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal><SectionTitle eyebrow="Browse by series" title="Podcast series" /></Reveal>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {series.map((s, i) => (
            <Reveal key={s.id} delay={i * 70}>
              <Link to={`/podcast/series/${s.slug}`} className="group block h-full bg-white rounded-2xl overflow-hidden border border-slate-100 shadow-sm hover:shadow-xl hover:-translate-y-1.5 transition-all duration-300">
                <div className="aspect-[16/10] overflow-hidden bg-navy">
                  {s.image ? <img loading="lazy" decoding="async" src={mediaUrl(s.image, 600)} alt={s.title} className="w-full h-full object-contain group-hover:scale-105 transition-transform duration-500" />
                    : <div className="w-full h-full flex items-center justify-center"><Headphones className="text-white/20" size={48} /></div>}
                </div>
                <div className="p-6">
                  <h3 className="font-display font-bold text-lg text-navy mb-2 group-hover:text-orange transition-colors">{s.title}</h3>
                  <p className="text-sm text-slate-500 leading-relaxed mb-4 line-clamp-2">{s.description}</p>
                  <span className="inline-flex items-center gap-1.5 text-sm font-bold text-orange group-hover:gap-3 transition-all">View series <ArrowRight size={15} /></span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
